module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/static-modal-app/img/layer-4@2x__54dcf06869ea2eebea4aaafdd2d3a7f7.png";